import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { EntiteConfig } from '@features/referentiel/config/entite.config';
import { Salarie } from '@features/referentiel/models/salarie';
import { ContactSearchRequest } from '@features/referentiel/models/contact-search-request';
import { Response } from '@features/referentiel/models/response';
import { AppSourceEnum } from 'pu-core-library';

@Injectable({
    providedIn: 'root'
})
export class SalarieService {

    constructor(private httpClient: HttpClient) { }

    getContactsBySiret(siret: string): Observable<Salarie[]> {
        const requestBody: ContactSearchRequest = {
            siret: siret
        };

        return this.httpClient.post<Response<Salarie>>(`${EntiteConfig.contactsList}?sourceCode=${AppSourceEnum.POF}`, requestBody)
            .pipe(
                map(data => data.response),
                catchError(error => {
                    return throwError(() => error);
                })
            );
    }
}